export default __webpack_public_path__ + "static/media/office1.a6ea02fe.jpg";